import React, { Component } from "react";
import PersonCard from "../components/PersonCard";

class Staff extends Component {
	constructor(props) {
		super(props);
		this.state = {
			people: [],
		};
	}
	componentDidMount() {
		const people = [
			{
				name: "भद्र बहादुर बस्नेत",
				nameEnglish: "Bhadra Bahadur Basnet",
				designation: "प्रमुख प्रशासकीय अधिकृत",
				designationEnglish: "Chief Administrative Officer",
				email: "N/A",
				phone: "N/A",
				phoneEnglish: "N/A",
				address: "सिन्धुपाल्चोक, बागमती प्रदेश, नेपाल",
				addressEnglish: "Sindulipalchowk rural municipality",
				image: "media/hamropalika/people/st2.jpg",
				containerClass: "col-sm-6 col-md-12 col-xl-6",
			},
			{
				name: "तेजप्रसाद ढकाल",
				nameEnglish: "Tej prasad dhakal",
				designation: "सूचना अधिकारी",
				designationEnglish: "Information Officer",
				email: "N/A",
				phone: "N/A",
				phoneEnglish: "N/A",
				address: "सिन्धुपाल्चोक, बागमती प्रदेश, नेपाल",
				addressEnglish: "Sindulipalchowk rural municipality",
				image: "media/hamropalika/people/st3.jpg",
				containerClass: "col-sm-6 col-md-12 col-xl-6",
			},
		];
		this.setState({ people });
	}
	render() {
		return (
			<div className="row h-100">
				{this.state.people.map((person, index) => {
					return <PersonCard data={person} key={index} />;
				})}
			</div>
		);
	}
}

export default Staff;
